import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";

const AgentNode = memo(({ data, selected }) => {
  const color = data.color || "#666";
  return (
    <div
      style={{
        background: "#fff",
        border: `2px solid ${selected ? "#1a1a1a" : color}`,
        borderRadius: 8,
        padding: "8px 14px",
        minWidth: 120,
        boxShadow: selected ? "0 0 0 2px rgba(0,0,0,0.15)" : "0 1px 3px rgba(0,0,0,0.08)",
        cursor: "pointer",
      }}
    >
      <Handle type="target" position={Position.Left} style={{ background: color, width: 8, height: 8 }} />
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <div
          style={{
            width: 8, height: 8, borderRadius: "50%",
            background: color, flexShrink: 0,
          }}
        />
        <div style={{ fontWeight: 600, fontSize: 12, color: "#333" }}>
          {data.label || data.agentId}
        </div>
      </div>
      {data.agentId && (
        <div style={{ fontSize: 10, color: "#999", fontFamily: "var(--font-mono)", marginTop: 2 }}>
          {data.agentId}
        </div>
      )}
      <Handle type="source" position={Position.Right} style={{ background: color, width: 8, height: 8 }} />
    </div>
  );
});

AgentNode.displayName = "AgentNode";
export default AgentNode;
